const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  status: "All",
  colors: [],
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    colorSelected: (state, action) => {
      state.colors.push(action.payload);
    },
    colorRemoved: (state, action) => {
      const indexToRemove = state.colors.indexOf(action.payload);

      if (indexToRemove !== -1) {
        state.colors.splice(indexToRemove, 1);
      }
    },
    resetColors: (state, action) => {
      state.colors = [];
    },
  },
});

export default filterSlice.reducer;
export const { setStatus, colorSelected, colorRemoved, resetColors } = filterSlice.actions;
